import React, { useState, useEffect, useRef } from 'react'
import axios from '~/data/http/axios'
import i18n from '~/i18n'
import Avatar from '~/Common-Objects/Avatar/Avatar'
import ButtonSelect from '~/Common-Objects/UI/Forms/ButtonSelect/ButtonSelect'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import AddGroup from '~/pages/cp/subscribers/groups/incGoAddGroup'

//nice standardised group selector, used in drawers
export default function GroupSelector({
    initialGroupId = -1,
    onSelect = () => {},
    groupChanged = () => {},
    skipSettingDefaultGroup = false
}) {
    const searchTimer = useRef(null)

    const [groups, setGroups] = useState([])
    const [selectedGroup, setSelectedGroup] = useState(null)
    const [searchText, setSearchText] = useState('')
    const [addingGroup, setAddingGroup] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getGroups(true)
    }, [])

    useEffect(() => {
        if (searchTimer.current) clearTimeout(searchTimer.current)
        searchTimer.current = setTimeout(() => getGroups(false), 300)
    }, [searchText])

    const getGroups = async (firstRun) => {
        var queryStr = ``
        if (searchText) queryStr += `?searchText=${searchText}`
        let response = await axios.get('/group/simple' + queryStr)
        let groups = response.data.Groups.sort((a, b) => {
            if (a.groupName < b.groupName) return -1
            if (a.groupName > b.groupName) return 1
            return 0
        })
        if (firstRun && groups.length && !skipSettingDefaultGroup) {
            let initialGroup = groups.find((group) => group.id == initialGroupId)
            if (initialGroup) {
                setSelectedGroup(initialGroup)
                groupChanged(initialGroup)
            } else {
                setSelectedGroup(groups[0])
                groupChanged(groups[0])
            }
        }
        setGroups(groups)
    }

    const updateSearchText = (text) => {
        setSearchText(text)
    }

    const setGroup = (group) => {
        setSelectedGroup(group)
        groupChanged(group)
        //external
        if (onSelect && typeof onSelect === 'function') {
            onSelect(selectedGroup)
        }
    }

    const startAddingGroup = () => {
        setAddingGroup(true)
        setGroup(null)
    }

    const addedGroup = (newGroup) => {
        const existingGroups = [...groups]
        existingGroups.push(newGroup.data.group)
        setGroups(groups)
        setLoading(false)
        setAddingGroup(false)
        setGroup(newGroup.data.group)
        if (onSelect && typeof onSelect === 'function') {
            onSelect(newGroup.data.group)
        }
    }

    if (loading) return <LoadingIcons iconType='2' />
    if (addingGroup) return <AddGroup addedGroup={addedGroup} dontCloseDrawer={true} />

    return (
        <>
            <ButtonSelect
                outerClassName='mar-b25'
                filter={true}
                autoClose={true}
                updateFilter={updateSearchText}
                headerText={selectedGroup ? selectedGroup.groupName : i18n.t('form:groupSelect.selectAGroup')}
                label={
                    <>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>{i18n.t('form:groupSelect.group')}</div>
                            <div>
                                <a onClick={startAddingGroup}>{i18n.t('form:groupSelect.createGroup')}</a>
                            </div>
                        </div>
                    </>
                }
                data={groups.map((group, index) => {
                    return (
                        <a
                            key={group.id}
                            onClick={() => setGroup(group)}
                            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                        >
                            <div>{group.groupName}</div>
                            {!!group.Applications?.length && (
                                <div className='quickFlex' style={{ gap: 4 }}>
                                    {group.Applications.map((app) => (
                                        <Avatar
                                            tooltip={app.appName}
                                            for={app.id}
                                            src={app.appLogoUri}
                                            style={{ height: 20, width: 20 }}
                                            key={app.id}
                                        />
                                    ))}
                                </div>
                            )}
                        </a>
                    )
                })}
            />
        </>
    )
}
